import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, getURLSegment, closeDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import DatePicker from 'react-datepicker';
import moment from 'moment';

// Components
import TimeSelect from '../Modules/TimeSelect';

const EditBlackoutDate = observer(class EditBlackoutDate extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleSubmit = this.handleSubmit.bind(this);

    // Set the initial state
    this.state = {
      startDate: null,
      endDate: null,
      blackoutDate: {
        startDate: null,
        endDate: null
      }
    }
  }

  componentWillMount() {
    const { BlackoutStore } = this.props.store;

    const callback = (response) => {
      const blackoutDate = {
        startDate: response.data.startDate,
        endDate: response.data.endDate
      };

      this.setState({
        startDate: response.data.startDate,
        endDate: response.data.endDate,
        blackoutDate
      });
    }

    // If we’re editing, get the blackout date
    if(getURLSegment(this, 2) === 'edit') {
      BlackoutStore.getBlackoutDate(getURLSegment(this, 3), callback);
    }
  }

  handleDateChange(date, name) {
    let time = this.startTime.value;

    if(name === 'endDate') {
      time = this.endTime.value;
    }

    this.updateDates(date, time, name);
  }

  handleTimeChange(name, e) {
    let date = this.state.startDate;

    if(name === 'endDate') {
      date = this.state.endDate;
    }

    this.updateDates(date, e.target.value, name);
  }

  updateDates(date, time, name) {
    const { SessionStore } = this.props.store;
    const { userTimezone } = SessionStore;
    const { blackoutDate } = this.state;

    const dateString = moment(date).format('YYYY-MM-DD');
    const timezoneString = moment(date).tz(userTimezone).format('Z');
    const dateAndTime = moment.utc(`${dateString} ${time} ${timezoneString}`, 'YYYY-MM-DD HH:mm Z')
                              .tz(userTimezone)
                              .toISOString();

    blackoutDate[name] = dateAndTime;

    this.setState({
      [name]: date,
      blackoutDate
    });
  }

  handleSubmit() {
    const { translation } = this.props;
    const { BlackoutStore, SessionStore } = this.props.store;
    let callback = null;

    if(getURLSegment(this, 2) === 'edit') {
      callback = () => {
        SessionStore.showToaster(translation.updated, 'success');
        closeDrawer(null, this, getURLSegment(this, 1));
      }

      BlackoutStore.updateBlackoutDate(getURLSegment(this, 3), this.state.blackoutDate, callback);
    } else {
      callback = () => {
        SessionStore.showToaster(translation.created, 'success');
        closeDrawer(null, this, getURLSegment(this, 1));
      }

      BlackoutStore.createBlackoutDate(this.state.blackoutDate, callback);
    }
  }

  render() {
    const { translation } = this.props;
    const { BlackoutStore, SessionStore } = this.props.store;
    const { blackoutDate } = BlackoutStore;
    const { userTimezone } = SessionStore;

    if(!SessionStore.loading) {
      return (
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              {getURLSegment(this, 2) === 'edit' &&
                <h1 className="drawer__title">{translation.heading}</h1>
              }

              {getURLSegment(this, 2) === 'add' &&
                <h1 className="drawer__title">{translation.heading_add}</h1>
              }
            </div>
          </header>

          <div className="wrap">
            <form
              className="panel panel--medium"
              onSubmit={(e) => checkValidity(e, this.handleSubmit)}
              noValidate
            >
              <fieldset>
                <ul className="fields fields--center">
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="blackout-start-date">
                      {translation.starts.label}
                    </label>

                    <DatePicker
                      id="blackout-start-date"
                      selected={
                        this.state.startDate ?
                        moment(this.state.startDate).tz(userTimezone) :
                        null
                      }
                      maxDate={this.state.endDate}
                      onChange={(date) => this.handleDateChange(date, 'startDate')}
                      placeholderText={translation.starts.helper}
                      required aria-required="true"
                      ref={(input) => this.startDate = input}
                      defaultValue={
                        blackoutDate ?
                        blackoutDate.startDate :
                        null
                      }
                      autoComplete="off"
                    />

                    <span className="preposition">{translation.starts.at}</span>

                    <TimeSelect
                      id="blackout-start-time"
                      defaultValue={this.state.startDate}
                      reference={(input) => this.startTime = input}
                      onChange={(e) => this.handleTimeChange('startDate', e)}
                      date={this.state.startDate}
                      name="startDate"
                      stateName="startTime"
                      {...this.props}
                      parent={this}
                    />

                    <span className="preposition">
                      {/* If a date is selected, use that date’s dst */}
                      {this.state.endDate &&
                        moment.utc(this.state.startDate).tz(userTimezone).format('z')
                      }

                      {/* Otherwise use the current date’s dst */}
                      {!this.state.endDate &&
                        moment().tz(userTimezone).format('z')
                      }
                    </span>
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="blackout-end-date">
                      {translation.ends.label}
                    </label>

                    <DatePicker
                      id="blackout-end-date"
                      selected={
                        this.state.endDate ?
                        moment(this.state.endDate).tz(userTimezone) :
                        null
                      }
                      minDate={this.state.startDate}
                      onChange={(date) => this.handleDateChange(date, 'endDate')}
                      placeholderText={translation.ends.helper}
                      required aria-required="true"
                      ref={(input) => this.endDate = input}
                      defaultValue={
                        blackoutDate ?
                        blackoutDate.endDate :
                        null
                      }
                      autoComplete="off"
                    />

                    <span className="preposition">{translation.ends.at}</span>

                    <TimeSelect
                      id="blackout-end-time"
                      defaultValue={this.state.endDate}
                      reference={(input) => this.endTime = input}
                      onChange={(e) => this.handleTimeChange('endDate', e)}
                      date={this.state.endDate}
                      name="endDate"
                      stateName="endTime"
                      {...this.props}
                      parent={this}
                    />

                    <span className="preposition">
                      {/* If a date is selected, use that date’s dst */}
                      {this.state.endDate &&
                        moment.utc(this.state.startDate).tz(userTimezone).format('z')
                      }

                      {/* Otherwise use the current date’s dst */}
                      {!this.state.endDate &&
                        moment().tz(userTimezone).format('z')
                      }
                    </span>
                  </li>
                </ul>
              </fieldset>

              <div className="panel__actions actions">
                <button
                  className="actions__btn actions__btn--primary"
                >
                  {translation.button}
                </button>
              </div>
            </form>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('EditBlackoutDate')(EditBlackoutDate);



// WEBPACK FOOTER //
// ./src/app/components/BlackoutDates/EditBlackoutDate.js